const genders = {
  FEMALE: { title: 'signup.field.gender.female', type: 'FEMALE', intl: true },
  MALE: { title: 'signup.field.gender.male', type: 'MALE', intl: true },
  UNSPECIFIED: { title: 'signup.field.gender.unspecified', type: 'UNSPECIFIED', intl: true },
};

const defaultTypes = [
  genders.FEMALE,
  genders.MALE,
];

const auTypes = [
  genders.MALE,
  genders.FEMALE,
  genders.UNSPECIFIED,
];

export default COUNTRY === 'AU' ? auTypes : defaultTypes;
